import React from 'react';
import { ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';
import { Avatar as MaterialAvatar } from '@mui/material';
import { host } from '../../supabaseClient';

const MessageCard = ({ id, date, content, title }) => {
  return (
    <ListItem alignItems="flex-start">
      <ListItemAvatar>
        <MaterialAvatar src={host + '/storage/v1/object/public/icons/' + id + '.png'} />
      </ListItemAvatar>
      <ListItemText
        primary={
          <Typography component="span" variant="body1" color="textPrimary">
            {title}
          </Typography>
        }
        secondary={
          <Typography component="div" variant="body2" color="textSecondary" dangerouslySetInnerHTML={{ __html: content }} />
        }
      />
    </ListItem>
  );
};

export default MessageCard;
